import React, { useState, useEffect } from 'react';
import { createMuiTheme, withStyles } from '@material-ui/core/styles';
import AWVApi from '../../assets/constants/AWVRafservice.Instance';
import Button from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import { connect } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';
import Divider from '@mui/material/Divider';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import pdfIcon from '../../assets/images/pdf_icon.png';
import Moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import AWS from 'aws-sdk';
const aws = require('aws-sdk');

const S3_BUCKET = 'bucket-awv-form-upload'; //process.env.REACT_APP_BUCKET_NAME_Two;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_ID;
const SECRET_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;

const styles = (theme) => ({
    dialogPaper: {
        maxWidth: '80%',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const AWVMemberDetails = (props) => {
    const { register, formState: { errors }, handleSubmit, reset, control, getValues, setValue } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;


    useEffect(() => {
        setValue('remark', props?.editFormData?.remark);
        setValue('HCC_Confirmed', props?.editFormData?.HCC_Confirmed);
        setValue('DX_description', props?.editFormData?.DX_description);
        setValue('DX_code', props?.editFormData?.DX_code);
        setValue('HCC_Description', props?.editFormData?.HCC_Description);
        setValue('HCC_Code', props?.editFormData?.HCC_Code);
        setValue('previous_hcc', props?.editFormData?.HCC_Code);
        setValue('CIN', props?.editFormData?.CIN);
    }, [props.editFormData]);

    const onSubmit = (data) => {
        setIsLoading(true);
        if (props?.editFormData?.CIN && props?.editFormData?.CIN != '') {
            let controlUser = JSON.parse(localStorage.getItem('controlUser'));
            data.cin = props?.editFormData?.CIN;
            if (props?.editFormData?.action && props?.editFormData?.action == 'Add') {
                data.created_by = controlUser?.user_id;
                data.created_on = Moment().format('YYYY-MM-DD HH:mm:ss');
                AWVApi.post('/create-hcc-details', data)
                    .then(res => {
                        setValue('remark', '');
                        setValue('HCC_Confirmed', '');
                        setValue('DX_description', '');
                        setValue('DX_code', '');
                        setValue('HCC_Description', '');
                        setValue('HCC_Code', '');
                        setValue('previous_hcc', '');
                        setValue('CIN', '');
                        props.loadFormData();
                        setIsLoading(false);
                        toast.success('Member HCC add success');
                        props.handleClose();
                    })
                    .catch(err => {
                        setIsLoading(false);
                        toast.error(err?.response?.data?.message);
                    })
            } else {
                data.updated_by = controlUser?.user_id;
                AWVApi.put('/update-member-hcc-details', data)
                    .then(res => {
                        setValue('remark', '');
                        setValue('HCC_Confirmed', '');
                        setValue('DX_description', '');
                        setValue('DX_code', '');
                        setValue('HCC_Description', '');
                        setValue('HCC_Code', '');
                        setValue('previous_hcc', '');
                        setValue('CIN', '');
                        props.loadFormData();
                        setIsLoading(false);
                        toast.success('Member HCC update success');
                        props.handleClose();
                    })
                    .catch(err => {
                        setIsLoading(false);
                        toast.error(err?.response?.data?.message);
                    })
            }
        }

    };


    return (
        <div>
            <MuiDialog
                open={props.open}
                onClose={props.handleClose}
                fullWidth={true}
                maxWidth={'sm'}
                className="awv_model_layout"
            >
                <DialogTitle id="create-group" onClose={props.handleClose}>
                    <strong>
                        {(props?.editFormData?.action && props?.editFormData?.action == 'Add') ?
                            'Member Detail Report ADD'
                            :
                            'Member Detail Report EDIT'
                        }
                    </strong>
                </DialogTitle>
                <Divider />
                <div className='row'>
                    <div className='col-lg-12'>
                        <form onSubmit={handleSubmit(onSubmit)} id="add-verification-model">
                            <DialogContent >
                                {isLoading && isLoading == true ?
                                    <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                        <CircularProgress />
                                    </div>
                                    :
                                    <></>
                                }
                                <div className="row mb-3">
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>HCC CODE</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="HCC_Code"
                                                value={props?.editFormData?.HCC_Code}
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField  {...field} variant="outlined" />
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.HCC_Code?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>HCC DESCRIPTION</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="HCC_Description"
                                                value={props?.editFormData?.HCC_Description}
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField  {...field} variant="outlined" />
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.HCC_Description?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>DX CODE</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="DX_code"
                                                value={props?.editFormData?.DX_code}
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField  {...field} variant="outlined" />
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.DX_code?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>DX DESCRIPTION</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="DX_description"
                                                value={props?.editFormData?.DX_description}
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField  {...field} variant="outlined" />
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.DX_description?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row  mb-3">
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>HCC CONFIRMED</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="HCC_Confirmed"
                                                value={props?.editFormData?.HCC_Confirmed}
                                                control={control}
                                                render={({ field }) => (
                                                    // <TextField  {...field} variant="outlined" />
                                                    <Select
                                                        {...field}
                                                        labelId="module-multiple-checkbox-label"
                                                        id="module-multiple-checkbox"
                                                        // value={selectModule}
                                                        // onChange={handleChange}
                                                        label="Module"
                                                        variant="outlined"
                                                        // MenuProps={MenuProps}
                                                        menuPlacement="top"
                                                    >
                                                        <MenuItem key={'confirmed'} value={'confirmed'} >
                                                            Confirmed
                                                        </MenuItem>
                                                        <MenuItem key={'not confirmed'} value={'not confirmed'} >
                                                            Not Confirmed
                                                        </MenuItem>
                                                        <MenuItem key={'no longer applicable'} value={'no longer applicable'} >
                                                            No Longer Applicable
                                                        </MenuItem>
                                                        <MenuItem key={'acute'} value={'acute'} >
                                                            Acute
                                                        </MenuItem>
                                                    </Select>
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.HCC_Confirmed?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                    <div className="col-lg-6 align-items-center">
                                        <div className='mb-1'><strong>REMARKS</strong></div>
                                        <FormControl fullWidth margin="dense" variant="outlined" style={{ 'min-width': '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-outlined-label">User Name</InputLabel> */}
                                            <Controller
                                                className="input-control"
                                                name="remark"
                                                value={props?.editFormData?.remark}
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField  {...field} variant="outlined" />
                                                )}
                                                rules={{
                                                    required: true,
                                                }}
                                            />
                                            {errors?.remark?.type === "required" && <label className="text-danger">This field is required</label>}
                                        </FormControl>
                                    </div>
                                </div>
                            </DialogContent>
                            <DialogActions className='mt-2'>
                                <Button type='button' variant="contained" color="grey" onClick={props.handleClose}>CANCEL</Button>
                                <Button type='submit'
                                    className={'mr-2 btn-custom-primary'}
                                    variant="contained"
                                    disabled={isLoading && isLoading == true ? true : false}
                                >
                                    {(props?.editFormData?.action && props?.editFormData?.action == 'Add') ?
                                        'ADD'
                                        :
                                        'EDIT'
                                    }
                                </Button>
                            </DialogActions>
                        </form>
                    </div>
                </div>
            </MuiDialog>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        userDetails: state.auth.userDetails,
        yearSelect: state.moduleFilter.yearSelect,
        providerGroupSelect: state.moduleFilter.providerGroupSelect,
        lobSelect: state.moduleFilter.lobSelect,
    };
}
export default (withStyles(styles), connect(mapStateToProps))(AWVMemberDetails);
